import React from "react";

const Washing_18 = React.forwardRef(
  ({ width = "32", height = "32", viewBox = "0 0 32 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 23L9 9H7L7 23H9Z" fill="black" />
        <path d="M17 9V23H15L15 9H17Z" fill="black" />
        <path d="M25 23V9H23V23H25Z" fill="black" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0H32V32H0V0ZM2 2H30V30H2V2Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_18;
